import React from "react";
import { Trans } from "react-i18next";

import useAnimation from "../../../hooks/useAnimation";
import ZipStockSVG from "../../../../static/animations/zipstocks/zipstocks-svg";
import Animation from "../../../../static/animations/zipstocks/what-is-zipstocks-animation.json";

const WhatIsZipStock = ({ content }) => {
  useAnimation({
    container: "#what-is-zipstocks__animation",
    animationData: Animation,
  });

  return (
    <>
      <div className="zipstocks what-is-zipstocks">
        <div className="container">
          <div className="row justify-content-center">
            <div
              id="what-is-zipstocks__animation"
              className="col-12 col-lg-5 col-xl-4 mb-5 mb-lg-0 text-center"
              data-sal="fade"
            />
            <div className="col-12 col-lg-5 col-xl-4 d-flex align-items-center">
              <div
                data-sal="slide-up"
                data-sal-duration="400"
                data-sal-easing="ease-in-quad"
              >
                <h2>
                  <Trans
                    i18nKey="zipstocks.whatIsZipStocks.title"
                    components={[<ZipStockSVG />]}
                  />
                </h2>
                <div
                  className="main-content"
                  dangerouslySetInnerHTML={{
                    __html: content.nodes[0].acfPartials.pContent,
                  }}
                />
                <a
                  className="button button-secondary"
                  href={content.nodes[0].acfPartials.pButtonUrl}
                  target="_blank"
                  rel="noopener noreferrer"
                >
                  {content.nodes[0].acfPartials.pButtonText}
                </a>
              </div>
            </div>
          </div>
        </div>
      </div>
    </>
  );
};

export default WhatIsZipStock;
